// DOMContentLoaded ensures elements exist before running JS
document.addEventListener('DOMContentLoaded', function () {
    const imageInput = document.getElementById('imageInput');
    const preview = document.getElementById('preview');
    const placeholder = document.getElementById('placeholder');
    const mainButton = document.getElementById('mainButton');
    const btnIcon = document.getElementById('btnIcon');
    const statusText = document.getElementById('statusText');

    // Safety check to prevent the "null" error
    if (!imageInput || !mainButton) return;

    // Logic to Handle Upload
    imageInput.addEventListener('change', function() {
        const file = this.files[0];

        if (file) {
            // Check file size (2MB)
            if (file.size > 2097152) {
                alert("File is too large! Please select an image under 2MB.");
                this.value = "";
                return;
            }

            const reader = new FileReader();
            reader.onload = function(e) {
                // 1. Show Image Preview
                preview.style.backgroundImage = `url(${e.target.result})`;
                
                // 2. Hide Placeholder
                placeholder.style.display = 'none';
                
                // 3. Change Button to "Remove" state
                btnIcon.classList.replace('fa-arrow-up-from-bracket', 'fa-trash-can');
                mainButton.classList.add('remove-mode');
                mainButton.removeAttribute('for'); // Prevent opening dialog again
                
                statusText.innerHTML = "Image uploaded successfully.";
            }
            reader.readAsDataURL(file);
        }
    });

    // Logic to Handle Click (Remove or Upload)
    mainButton.addEventListener('click', function(e) {
        if (mainButton.classList.contains('remove-mode')) {
            e.preventDefault(); // Stop file browser from opening
            
            // 1. Reset Preview
            preview.style.backgroundImage = 'none';
            placeholder.style.display = 'block';
            
            // 2. Reset Button
            btnIcon.classList.replace('fa-trash-can', 'fa-arrow-up-from-bracket');
            mainButton.classList.remove('remove-mode');
            mainButton.setAttribute('for', 'imageInput');
            
            // 3. Clear Input
            imageInput.value = "";
            statusText.innerHTML = "Optional. Max 2MB, jpg/png.";
        }
    });
});

// Toggle Password Visibility
function togglePass(id, el) {
    const input = document.getElementById(id);
    if (input.type === "password") {
        input.type = "text";
        el.classList.replace('fa-eye-slash', 'fa-eye');
    } else {
        input.type = "password";
        el.classList.replace('fa-eye', 'fa-eye-slash');
    }
}